// Reemplazar starkenVar por la inicial del modelo
// Reemplazar Starken por el nombre del Modelo
// Reemplazar starken por el nombre del modelo
var starken = {
	data() {
		return {
			emitiendoOrdenFleteStarken: false,
			listStarkens: [],
			listStarkenAgencias: [],
			listStarkenCiudades: [],
			loadingStarkens: false,
			paginationStarkens: [],
			objectStarken: {
				exists: 0,
				id: 0,
				rut: '',
				dvRut: '',
				nombreRazonSocial: '',
				direccion: '',
				numeracionDireccion: '',
				comuna: '',
				telefono: '',
				email: '',
				nombreContacto: '',
				tipoEntrega: 2, // 1 Agencia o 2 Domicilio
				tipoPago: '2', // 2 CtaCte o 3 Por Pagar
				valorDeclarado: 0,
				contenido: 'Libros',
				kilosTotal: '',
				alto: '',
				ancho: '',
				largo: '',
				tipoServicio: 0, // 0 Normal o 1 Express
				documentos: [],
				encargos: [],
				observacion: '',
				created_at: null,
				updated_at: null,
			},
			savingStarken: false,
			searchingStarken: false,
			searchingStarkenAgencias: false,
			searchingStarkenCiudades: false,
			searchStarkens: ''
		}
	},
	computed: {
		listStarkenComunas() {
			let list = []
			this.listStarkenCiudades.forEach(ciu => {
				ciu.listaComunas.forEach(com => {
					let comuna = this.selectComunaByStr(com.nombreComuna)
					if(comuna.id > 0) {
						list.push({
							codigoCiudad: ciu.codigoCiudad,
							codigoRegion: ciu.codigoRegion,
							codigoComuna: com.codigoComuna,
							name: com.nombreComuna,
							id: comuna.id,
							region_synthetic: comuna.region_synthetic
						})
					}
				})
			});
			return list
		}
	},
	methods: {
		addItemListStarkens(starkenVar) {
			this.listStarkens.unshift(starkenVar)
		},
		clearObjectStarken() {
			this.objectStarken.exists = 0
			this.objectStarken.id = 0
			this.objectStarken.starken = ''
			this.objectStarken.created_at = null
			this.objectStarken.updated_at = null
		},
		emitirOrdenFleteStarken(
			shippingId,
			rut,
			dvRut,
			nombreRazonSocial,
			apellidoPaterno,
			apellidoMaterno,
			direccion,
			numeracionDireccion,
			departamentoDireccion,
			comuna,
			telefono,
			email,
			nombreContacto,
			tipoEntrega,
			tipoPago,
			valorDeclarado,
			contenido,
			kilosTotal,
			alto,
			ancho,
			largo,
			tipoServicio,
			documentos,
			encargos
		) {
			let url = this.getApiBackendNew + 'starken/emision'
			let param = {
				shippingId: shippingId,
				rut: rut,
				dvRut: dvRut,
				nombreRazonSocial: nombreRazonSocial,
				apellidoPaterno: apellidoPaterno,
				apellidoMaterno: apellidoMaterno,
				direccion: direccion,
				numeracionDireccion: numeracionDireccion,
				departamentoDireccion: departamentoDireccion,
				comuna: comuna,
				telefono: telefono,
				email: email,
				nombreContacto: nombreContacto,
				tipoEntrega: tipoEntrega,
				tipoPago: tipoPago,
				valorDeclarado: valorDeclarado,
				contenido: contenido,
				kilosTotal: kilosTotal,
				alto: alto,
				ancho: ancho,
				largo: largo,
				tipoServicio: tipoServicio,
				documentos: documentos,
				encargos: encargos
			}
			console.log(url, 'POST', 'emitirOrdenFleteStarkenResult', param)
			this.emitiendoOrdenFleteStarken = true
			this.axiosActionIS(url, 'POST', 'emitirOrdenFleteStarkenResult', param)
		},
		emitirOrdenFleteStarkenResult(response) {
			this.emitiendoOrdenFleteStarken = false
			this.emitirOrdenFleteStarkenResultLocal(response)
		},
		emitirOrdenFleteStarkenResultLocal(response) {
			console.log('emitirOrdenFleteStarkenResultLocal no desarrollado', response)
		},
		getEtiquetaZPLStarken(ordenFlete) {
			let url = this.getApiBackendNew + 'starken/generarEtiqueta?ordenFlete=' + ordenFlete
			this.emitiendoOrdenFleteStarken = true
			this.axiosActionIS(url, 'GET', 'getEtiquetaZPLStarkenResult')
		},
		getEtiquetaZPLStarkenResult(response) {
			this.emitiendoOrdenFleteStarken = false
			this.getEtiquetaZPLStarkenResultLocal(response)
		},
		getEtiquetaZPLStarkenResultLocal(response) {
			console.log('getEtiquetaZPLStarkenResultLocal no desarrollado', response)
		},
		getStarkenAgencias(option = '') {
			this.searchingStarkenAgencias = true
			this.listStarkenAgencias = []
			let param = '?option=' + option
			let url = this.getApiBackendNew + 'starken/agencias' + param
			this.axiosActionIS(url, 'GET', 'getStarkenAgenciasResult')
		},
		getStarkenAgenciasResult(response) {
			this.searchingStarkenAgencias = false
			if (response.data.success == true) {
				this.listStarkenAgencias = response.data.data
			}			
			this.getStarkenAgenciasResultLocal(response)
		},
		getStarkenAgenciasResultLocal(response) {
			console.log('getStarkenAgenciasResultLocal no desarrollado', response)
		},
		getStarkens(page = 1) {
			this.listStarkens = []
			this.paginationStarkens = []
			this.loadingStarkens = true
			let param = '?page=' + page + '&search=' + this.searchStarkens
			let url = this.getApiBackendNew + 'starkens' + param
			this.axiosActionIS(url, 'GET', 'getStarkensResult')
		},
		getStarkensResult(response) {
			this.loadingStarkens = false
			if (response.data.success == true) {
				this.listStarkens = response.data.data
				this.paginationStarkens = response.data.paginate
			}
			this.getStarkensResultLocal(response)
		},
		getStarkensResultLocal(response) {
			console.log('getStarkensResultLocal no desarrollado', response)
		},
		getStarkenCiudades(option = 'Destino') {
			this.searchingStarkenCiudades = true
			this.listStarkenCiudades = []
			let param = '?option=' + option
			let url = this.getApiBackendNew + 'starken/ciudades' + param
			this.axiosActionIS(url, 'GET', 'getStarkenCiudadesResult')
		},
		getStarkenCiudadesResult(response) {
			this.searchingStarkenCiudades = false
			if (response.data.success == true) {
				this.listStarkenCiudades = response.data.data
			}
			this.getStarkenCiudadesResultLocal(response)
		},
		getStarkenCiudadesResultLocal(response) {
			console.log('getStarkenCiudadesResultLocal no desarrollado', response)
		},
		saveStarken(starkenVar) {
			this.savingStarken = true
			let method = (starkenVar.id == 0) ? 'POST' : 'PUT'
			let url = this.getApiBackendNew + 'starken/'
			url += (method == 'POST') ? 'register' : starkenVar.id + '/update'
			this.axiosActionIS(url, method, 'saveStarkenResult', starkenVar)
		},
		saveStarkenResult(response) {
			this.savingStarken = false
			if (response.data.success == true) {
				this.setObjectStarken(response.data.data)
			}
			this.saveStarkenResultLocal(response)
		},
		saveStarkenResultLocal(response) {
			console.log('saveStarkenResultLocal no desarrollado', response)
		},
		setObjectStarken(starkenVar) {
			this.clearObjectStarken()
			for (const property in starkenVar) {
				this.objectStarken[property] = r[property]
			}
		},
		showStarken(id) {
			this.searchingStarken = true
			let url = this.getApiBackendNew + 'starken/' + id
			this.axiosActionIS(url, 'GET', 'showStarkenResult')
		},
		showStarkenResult(response) {
			this.searchingStarken = false
			if (response.data.success == true) {
				this.setObjectStarken(response.data.data)
			}
			this.showStarkenResultLocal(response)
		},
		showStarkenResultLocal(response) {
			console.log('showStarkenResultLocal no desarrollado', response)
		},
	},
};

export default starken;